import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getEmiBanksList } from '@/api/srp/emi'

import { RootState } from '@/redux/store/configureStore'

const initialState = {
  emiBanksData: {},
  selectedFlightData: {},
  emiPopup: {
    show: false,
  }
}

export const fetchEmiBanksData = createAsyncThunk('emiAffordability/affordability', async payload => {
  const response = await getEmiBanksList(payload)
  return response
})

export const emiAffordabilitySlice = createSlice({
  name: 'emiAffordability',
  initialState,
  reducers: {
    setSelectedFlight: (state, action) => {
      state.selectedFlightData = action.payload
    },
    setEmiBanksData: (state, action) => {
      state.emiBanksData = action.payload
    },
    setEmiPopup: (state, action) => {
      state.emiPopup = action.payload
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchEmiBanksData.pending, (state, action) => {
      state.emiBanksData.loading = true
    })
    builder.addCase(fetchEmiBanksData.fulfilled, (state, action) => {
      if (action.payload?.data && action.payload?.data?.emi_providers) {
        state.emiBanksData = action.payload.data
      } else {
        state.emiBanksData = { error: true }
      }
    })
    builder.addCase(fetchEmiBanksData.rejected, (state, action) => {
      state.emiBanksData = { error: true }
    })
  },
})

const emiBanksData = (state: RootState) => state.emiAffordability.emiBanksData

const selectedFlightData = (state: RootState) => state.emiAffordability.selectedFlightData

const emiPopup = (state: RootState) => state.emiAffordability.emiPopup

const { reducer, actions } = emiAffordabilitySlice

const { setSelectedFlight, setEmiBanksData, setEmiPopup } = actions

export { emiBanksData, selectedFlightData, emiPopup, setSelectedFlight, setEmiBanksData, setEmiPopup }

export default reducer
